import { Trans } from "@lingui/react";
import { useWaiterRouter } from '@segments/Routing/client';
import { useResetPersistence } from '@segments/Storage';
import * as React from 'react';
import { ButtonLarge } from '~ui/components/buttons/ButtonSizes/ButtonLarge';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Resets the persistence (branchId cookie, order ID, menu params, machines of the home screen), than redirect to the *HomeScreen*.
 */
export var CreateNewOrderButton = function CreateNewOrderButton() {
  var router = useWaiterRouter();
  var resetPersistence = useResetPersistence();

  var onClick = function onClick() {
    // reset persistence
    resetPersistence(); // redirect home

    router.replace("home");
  };

  return /*#__PURE__*/_jsx(ButtonLarge, {
    bgColor: "secondary",
    onClick: onClick,
    children: /*#__PURE__*/_jsx(Trans, {
      id: "gpOgSF"
    })
  });
};